export default __webpack_public_path__ + "static/media/Billy.3de95566.png";